import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import NotifyMarketplace from './component';

import style from '../style.module.less';

const notifyMarketplace = {
  id: 'markAsShipped.columns.notifyMarketplace',
  defaultMessage: 'Notify Marketplace',
};

const GetName = () => {
  const intl = useIntl();

  return intl.formatMessage(notifyMarketplace);
};

export default {
  id: 'mark-as-shipped-notifyMarketplace',
  index: 7,
  isDragable: false,
  minWidth: 100,
  width: 100,
  nonsortable: true,
  getName: GetName,
  name: (
    <div className={style['long-column-header']}>
      <FormattedMessage {...notifyMarketplace} />
    </div>
  ),
  render: (data) => {
    return <NotifyMarketplace fulfillmentPlanId={data.id} />;
  },
};
